<div class="boards-container">
  <legend>Boards</legend>
  <div class="boards-header">
    <input
      type="text"
      class="form-control"
      style="max-width: 800px"
      [(ngModel)]="searchText"
      (ngModelChange)="filterSchedulingTeams()"
      placeholder="Search scheduling teams, clients, drivers..."
    />
  </div>

  <div class="clients-list" *ngIf="!isLoading && filteredClientGroups.length > 0">
    <div class="client-section" *ngFor="let clientGroup of filteredClientGroups">
      <!-- Client Section Header -->
      <div class="client-section-header">
        <i class="fa fa-building client-icon"></i>
        <span class="client-name">{{ clientGroup.clientName }}</span>
        <span class="client-stats">
          {{ clientGroup.schedulingTeams.length }} Scheduling Team{{
            clientGroup.schedulingTeams.length !== 1 ? "s" : ""
          }}
        </span>
      </div>

      <!-- Client Scheduling Teams -->
      <div class="client-boards">
        <div class="board-card" *ngFor="let schedulingTeam of clientGroup.schedulingTeams">
          <!-- Scheduling Team Header -->
          <div class="board-header" (click)="toggleSchedulingTeamExpansion(schedulingTeam.id!)">
            <div class="board-header-left">
              <i
                class="fa"
                [ngClass]="
                  isSchedulingTeamExpanded(schedulingTeam.id!)
                    ? 'fa-chevron-down'
                    : 'fa-chevron-right'
                "
              ></i>
              <span class="board-name" [innerHTML]="highlightText(schedulingTeam.name)"></span>
              <span class="board-stats">
                <span class="stat-badge driver-badge">
                  <i class="fa fa-user"></i> {{ schedulingTeam.drivers.length }}
                </span>
              </span>
            </div>
          </div>

          <!-- Scheduling Team Body (Expandable) -->
          <div class="board-body" *ngIf="isSchedulingTeamExpanded(schedulingTeam.id!)">
            <!-- Condensed Layout -->
            <div class="board-content-grid">
              <!-- Contacts Section -->
              <div
                class="contact-section"
                *ngIf="schedulingTeam.contacts && schedulingTeam.contacts.length > 0"
              >
                <div class="section-label">Contacts:</div>
                <div class="contacts-list">
                  <div class="contact-row" *ngFor="let contact of schedulingTeam.contacts">
                    <div class="contact-name">
                      <strong>{{ contact.name }}</strong>
                      <span class="contact-role" *ngIf="contact.role">({{ contact.role }})</span>
                    </div>
                    <div class="contact-email" *ngIf="contact.email">
                      <i class="fa fa-envelope"></i>
                      <span>{{ contact.email }}</span>
                    </div>
                    <div class="contact-phone" *ngIf="contact.phone">
                      <i class="fa fa-phone"></i>
                      <span>{{ contact.phone | phoneNumber }}</span>
                    </div>
                    <div class="contact-do-not-contact" *ngIf="contact.doNotContact">
                      ⚠️ Do Not Contact
                    </div>
                  </div>
                </div>
              </div>

              <!-- Driver Assignments -->
              <div class="drivers-section">
                <div class="drivers-header">
                  <div class="section-label">Drivers:</div>
                </div>

                <div class="drivers-compact" *ngIf="schedulingTeam.drivers.length > 0">
                  <div class="driver-row" *ngFor="let driver of schedulingTeam.drivers">
                    <span class="driver-name" [innerHTML]="getDriverNameHighlighted(driver)"></span>

                    <!-- Assignment Display (Inline) -->
                    <div class="assignment-inline">
                      <div
                        class="assignment-badges"
                        *ngIf="driver.boardName || driver.billToClientName; else noAssignment"
                      >
                        <span class="board-badge" *ngIf="driver.boardName">
                          <i class="fa fa-tag"></i>
                          {{ driver.boardName }}
                        </span>
                        <span class="billto-badge" *ngIf="driver.billToClientName">
                          <i class="fa fa-building"></i>
                          {{ driver.billToClientName }}
                        </span>
                      </div>
                      <ng-template #noAssignment>
                        <span class="no-assignment">Unassigned</span>
                      </ng-template>
                      <button
                        class="btn btn-sm btn-primary"
                        (click)="
                          openEditDriverModal(schedulingTeam, driver); $event.stopPropagation()
                        "
                        title="Edit Assignment"
                        *ngIf="hasPermission('BoardsChange')"
                      >
                        <i class="fa fa-pencil"></i> Edit
                      </button>
                    </div>
                  </div>
                </div>
                <div class="empty-text" *ngIf="schedulingTeam.drivers.length === 0">
                  No drivers assigned
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="loading-spinner" *ngIf="isLoading">
    <i class="fa fa-spinner fa-spin"></i> Loading scheduling teams...
  </div>

  <div
    class="no-boards"
    *ngIf="
      !isLoading && filteredClientGroups.length === 0 && filteredUnassignedDrivers.length === 0
    "
  >
    <i class="fa fa-clipboard"></i>
    <p>No scheduling teams found</p>
  </div>

  <!-- Unassigned Drivers Section -->
  <div
    class="unassigned-drivers-section"
    *ngIf="!isLoading && filteredUnassignedDrivers.length > 0"
  >
    <div class="section-header">
      <h4>
        <i class="fa fa-user-plus"></i> Unassigned Drivers ({{ filteredUnassignedDrivers.length }})
      </h4>
    </div>
    <div class="unassigned-drivers-list">
      <div class="unassigned-driver-item" *ngFor="let driver of filteredUnassignedDrivers">
        <div class="driver-info">
          <i class="fa fa-user"></i>
          <span [innerHTML]="getUnassignedDriverNameHighlighted(driver)"></span>
        </div>
        <button
          class="btn btn-sm btn-primary"
          (click)="openAssignDriverModal(driver)"
          *ngIf="hasPermission('BoardsChange')"
          title="Assign to Scheduling Team"
        >
          <i class="fa fa-plus"></i> Assign
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Assign / Edit Driver Modal -->
<app-assign-driver-modal
  [(visible)]="showAssignModal"
  [driverId]="assignModalDriverId"
  [existingTeamId]="assignModalExistingTeamId"
  [existingBoardId]="assignModalExistingBoardId"
  [existingBillToId]="assignModalExistingBillToId"
  (assignSuccess)="onAssignSuccess($event)"
  (updateSuccess)="onUpdateSuccess()"
  (unassignSuccess)="onUnassignSuccess()"
></app-assign-driver-modal>
